import React from 'react';
import styled from 'styled-components';
import { device } from '../utils/devices';

const Block = styled.section`
  display: flex;
  flex-direction: column-reverse;

  @media ${device.laptop} {
    display: grid;
    grid-template-columns: 4.5fr 1fr;
    direction: ${props => props.left ? 'rtl' : 'ltr' };
  }
`;

const Content = styled.div`
  @media ${device.laptop} {

    .slick-list {
       width: 82vw;
     }
  }
`;

const Sidebar = styled.aside`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${props => props.theme.bg}
`;

const Title = styled.h1`
  font-weight: 200;

  @media ${device.laptop} {
    writing-mode: vertical-rl;
    font-size: 3vw;
    transform: ${props => props.left ? 'rotate(180deg)' : 'none' };
  }


  span {
    display: none;

    @media ${device.laptop} {
      display: inline-block;
      font-family: 'AppleMyungjo';
      margin: ${props => props.left ? '0 0 1rem 0' : '1rem 0 0 0' }
    }
  }
`;

const Section = (props) => {
  return (
    <Block {...props} className={props.left ? 'left' : 'right'}>
      <Content>{props.children}</Content>
      <Sidebar>
        <Title {...props}>
          {props.title} {props.left ? <span>&#10553;</span> : <span>&#10549;</span>}
        </Title>
      </Sidebar>
    </Block>
  )
}

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section.js